/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useHistory, useLocation } from "react-router-dom";
import { pages } from "../../constants/PagePaths";
import { util } from "../../config/util";
import { Cookies } from "../../constants/Cookies";
import AlertContext from "../../contexts/AlertContext";
import { LectureCategoryModel, LectureItem } from "../../models/LectureModel";
import { api } from "../../config/api";
import { CategoryItem } from "../../models/CategoryItem";
import { FreeUseDay } from "../../constants/General";
import CategorySelector from "../../components/selector/categorySelector/CategorySelector";

interface Props {}

export default (props: Props) => {
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(0);
  const [lecturesData, setLecturesData] = useState<LectureItem[]>();
  const [lectures, setLectures] = useState<LectureItem[]>();
  const [lectureCategories, setLectureCategories] = useState<CategoryItem[]>();
  const history = useHistory();
  const location = useLocation();
  const alert = useContext(AlertContext);

  useEffect(() => {
    const key = util.getCookie(Cookies.authKey);
    if (!key) {
      alert.showAlert(
        "로그인 후 이용해주세요.\n회원가입시 " +
          FreeUseDay +
          "일 무료기간 제공중입니다.",
        () => {
          history.replace(pages.login);
        }
      );
      return;
    }

    (async () => {
      try {
        const lecturesResponse = await api.getLectureAsync();
        const data: LectureItem[] = lecturesResponse.data.lectures.map(
          (lecture: any) => ({
            id: lecture.id,
            thumbnailUrl: lecture.thumbnail_url,
            description: lecture.description,
            link: lecture.link,
            created: lecture.created,
            categoryId: lecture.category_id,
            order: lecture.order,
            title: lecture.name,
          })
        );
        setLecturesData(data);

        const categoryRes = await api.getLectureCategoryAsync();
        const categories: CategoryItem[] =
          categoryRes.data.lecture_categories
            ?.sort((a: any, b: any) => a.order - b.order)
            .map((lc: LectureCategoryModel) => ({
              title: lc.name,
              description: lc.description,
              id: lc.id,
            }));
        setLectureCategories(categories);

        const categoryIndex = +location.pathname.split("/")[2] || 0;
        setSelectedCategoryIndex(categoryIndex);
        setLectures(
          data.filter(
            (lecture) => lecture.categoryId === categories?.[categoryIndex]?.id
          )
        );
      } catch (e) {
        console.error("강의 데이터 로드 실패:", e);
      }
    })();
  }, []);

  const handleClickCategory = (index: number) => {
    setSelectedCategoryIndex(index);
    setLectures(
      lecturesData?.filter(
        (lecture) => lecture.categoryId === lectureCategories?.[index]?.id
      )
    );
  };

  const handleClickPlay = (id: number) => {
    history.push(`${pages.lectureroom}/${selectedCategoryIndex}/${id}`);
  };

  return (
    <>
      <Helmet>
        <title>무료 강의 | 콘엑스 - 건설 적산 프로그램 사용법</title>
        <meta name="description" content="콘엑스 건설 적산 프로그램 무료 강의. 초보자도 쉽게 따라할 수 있는 적산, 견적서 작성, 일위대가 검증 사용법을 배워보세요." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <main id="wrap" className="bg-light">
        <section className="page-top-banner">
        <div className="container">
          <div className="text-box">
            <div>콘엑스를 처음 경험하는</div>
            <h2>이용자들을 위한 무료강의</h2>
          </div>
        </div>
      </section>
      <section>
        <div className="container page">
          <div className="section-header">무료 강의</div>
          <div className="frame" style={{ overflow: "hidden" }}>
            <CategorySelector
              categories={lectureCategories}
              onClickCategory={handleClickCategory}
              selectedCategoryIndex={selectedCategoryIndex}
            />
            <div
              className="card-wrap column3 aos-init aos-animate"
              data-aos="fade-up"
              data-aos-duration="1000"
              style={{ paddingTop: "24px" }}
            >
              {lectures?.map((lecture) => (
                <div
                  className="card pointer"
                  key={lecture.id}
                  onClick={() => handleClickPlay(lecture.id)}
                >
                  <img
                    src={
                      lecture.thumbnailUrl ||
                      `https://img.youtube.com/vi/${lecture.link}/0.jpg`
                    }
                    className="card-img-top"
                    alt={lecture.title}
                    style={{ aspectRatio: "16/9", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{lecture.title}</h5>
                    <div className="body2 mb-2">{lecture.description}</div>
                    <button
                      className="btn btn-outline-primary right-icon"
                      type="button"
                    >
                      강의 듣기
                      <span className="material-symbols-outlined ms-2">
                        play_circle
                      </span>
                    </button>
                  </div>
                </div>
              ))}
              {lectures?.length === 0 && (
                <div style={{ padding: "40px 0", color: "#999", textAlign: "center", width: "100%" }}>
                  해당 카테고리에 강의가 없습니다.
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};
